import _IconSearch from "@arco-design/web-react/icon/react-icon/IconSearch";
import _IconBranch from "@arco-design/web-react/icon/react-icon/IconBranch";
import _IconThunderbolt from "@arco-design/web-react/icon/react-icon/IconThunderbolt";
import _IconApps from "@arco-design/web-react/icon/react-icon/IconApps";
import _IconFile from "@arco-design/web-react/icon/react-icon/IconFile";
import _IconStamp from "@arco-design/web-react/icon/react-icon/IconStamp";
import _IconPalette from "@arco-design/web-react/icon/react-icon/IconPalette";
import _IconPublic from "@arco-design/web-react/icon/react-icon/IconPublic";
import _IconList from "@arco-design/web-react/icon/react-icon/IconList";
import _IconCommon from "@arco-design/web-react/icon/react-icon/IconCommon";
import _IconInfoCircle from "@arco-design/web-react/icon/react-icon/IconInfoCircle";
import _IconUser from "@arco-design/web-react/icon/react-icon/IconUser";
import IconPublicIp from '@/assets/icons/public-ip.svg';
/** 未匹配到任何路由（含站点根路径 /）时的落地页（key 必须存在于下方配置中） */

export const defaultRouteKey = 'project/pops';
/**
 * 唯一的路由数据源。
 *
 * 新增一个「作用域」只需要在这里加一段配置：
 *   - 需要独立菜单时给节点加 `menuContainer: true`
 *   - 需要独立外壳时给节点加 `layout: 'xxx'`，并在 layouts/registry 注册
 * layout / 菜单 / 面包屑都会自动跟随，无需改动任何布局代码。
 */

export const routeConfig = [// ============================ 根作用域（菜单 = 顶层节点） ============================
{
  key: 'account',
  path: '/account',
  name: 'menu.account',
  // 独立作用域: 进入 /account/* 时侧边栏菜单切换为它的 children (profile)。
  menuContainer: true,
  // 入口已移到 NavBar 用户下拉, 不再出现在侧边栏根菜单中
  menu: {
    hide: true,
    icon: _IconUser,
    order: 20
  },
  redirectTo: 'account/profile',
  children: [{
    key: 'account/profile',
    path: 'profile',
    name: 'menu.account.profile',
    component: () => import('@/pages/account/profile'),
    menu: {
      icon: _IconInfoCircle
    }
  }]
}, {
  key: 'team',
  path: '/team',
  name: 'menu.team',
  // 独立作用域: 命中 /team/* 时侧边栏菜单切换为它的 children (info/member/projects),
  // 不再回落到根菜单。
  menuContainer: true,
  // 入口已移到 NavBar 用户下拉 (仅 admin 可见), 不再出现在侧边栏根菜单中
  menu: {
    hide: true,
    icon: _IconCommon,
    order: 30
  },
  // 团队管理只有 admin 可见/可进 (members.role): 非 admin 菜单隐藏, 直达 URL 落 403
  roles: ['admin'],
  redirectTo: 'team/info',
  children: [{
    key: 'team/info',
    path: 'info',
    name: 'menu.team.info',
    component: () => import('@/pages/team/info'),
    menu: {
      icon: _IconInfoCircle
    }
  }, {
    key: 'team/member',
    path: 'member',
    name: 'menu.team.member',
    component: () => import('@/pages/team/member'),
    menu: {
      icon: _IconUser
    } // menu: {
    //   badge: (
    //     <Tag color="blue" size="small">
    //       Team
    //     </Tag>
    //   ),
    // },

  }, {
    key: 'team/projects',
    path: 'projects',
    name: 'menu.team.projects',
    component: () => import('@/pages/team/projects'),
    menu: {
      icon: _IconList
    }
  }, {
    key: 'team/domain',
    path: 'domain',
    name: 'menu.team.domain',
    component: () => import('@/pages/team/domain'),
    menu: {
      icon: _IconPublic
    }
  }, {
    key: 'team/branding',
    path: 'branding',
    name: 'menu.team.branding',
    component: () => import('@/pages/team/branding'),
    menu: {
      icon: _IconPalette
    }
  }, {
    key: 'team/subscription',
    path: 'subscription',
    name: 'menu.team.subscription',
    component: () => import('@/pages/team/subscription'),
    menu: {
      icon: _IconStamp
    }
  }, {
    key: 'team/invoices',
    path: 'invoices',
    name: 'menu.team.invoices',
    component: () => import('@/pages/team/invoices'),
    menu: {
      icon: _IconFile
    }
  } // {
  //   key: 'team/upgrade',
  //   path: 'upgrade',
  //   name: 'menu.team.order',
  //   component: () => import('@/pages/team/upgrade'),
  // },
  ]
}, // ============================ /project 作用域 ============================
{
  key: 'project',
  path: '/project',
  name: 'menu.project',
  menuContainer: true,
  // 命中它时菜单切换为它的 children
  redirectTo: 'project/pops',
  // /project 自动跳到 pops
  // 入口已移到 NavBar，不再出现在侧边栏根菜单中
  menu: {
    hide: true,
    icon: _IconApps
  },
  children: [{
    key: 'project/pops',
    path: 'pops',
    name: 'menu.project.pops',
    component: () => import('@/pages/project/pops'),
    menu: {
      icon: _IconThunderbolt,
      order: 10
    }
  }, {
    key: 'project/cidr',
    path: 'cidr',
    name: 'menu.project.cidr',
    component: () => import('@/pages/project/cidr'),
    menu: {
      icon: IconPublicIp,
      order: 20
    }
  }, {
    key: 'project/tenants',
    path: 'tenants',
    name: 'menu.project.tenants',
    component: () => import('@/pages/project/tenants'),
    menu: {
      icon: _IconCommon,
      order: 30
    }
  }]
}, // ============================ /tenant/:tenantId 作用域 ============================
{
  key: 'tenant',
  path: '/tenant/:tenantId',
  name: 'menu.tenant',
  menuContainer: true,
  redirectTo: 'tenant/topology',
  menu: {
    hide: true,
    icon: _IconBranch
  },
  // 路径需要 id，不能作为根菜单入口
  children: [{
    key: 'tenant/monitoring',
    path: 'monitoring',
    name: 'menu.tenant.monitoring',
    // 直接访问 /tenant/<tenantId>/monitoring 时落到该组第一个页面
    redirectTo: 'tenant/topology',
    menu: {
      icon: _IconSearch,
      order: 10
    },
    children: [{
      key: 'tenant/topology',
      path: 'topology',
      name: 'menu.tenant.topology',
      component: () => import('@/pages/tenant/topology'),
      menu: {
        order: 10
      }
    } // {
    //     key: 'tenant/events',
    //     path: 'events',
    //     name: 'menu.tenant.events',
    //     component: () => import('@/pages/tenant/events'),
    //     menu: { order: 10 },
    // }
    ]
  }, {
    key: 'tenant/network',
    path: 'network',
    name: 'menu.tenant.network',
    // 直接访问 /tenant/<tenantId>/network 时落到该组第一个页面
    redirectTo: 'tenant/network/sites',
    menu: {
      icon: _IconPublic,
      order: 10
    },
    children: [{
      key: 'tenant/network/sites',
      path: 'sites',
      name: 'menu.tenant.network.sites',
      component: () => import('@/pages/tenant/sites'),
      menu: {
        order: 1
      }
    }, {
      key: 'tenant/network/rules',
      path: 'rules',
      name: 'menu.tenant.network.rules',
      component: () => import('@/pages/tenant/rules'),
      menu: {
        order: 2
      }
    }, {
      key: 'tenant/network/bandwidth',
      path: 'bandwidth',
      name: 'menu.tenant.network.bandwidth',
      component: () => import('@/pages/tenant/bandwidth'),
      menu: {
        order: 3
      }
    }, {
      key: 'tenant/network/eips',
      path: 'eips',
      name: 'menu.tenant.network.eips',
      component: () => import('@/pages/tenant/eips'),
      menu: {
        order: 4
      }
    }]
  }, // ===== 短路径别名(菜单里隐藏) =====
  // 手敲 / 分享 /tenant/<tenantId>/topology 这类短链接时, 自动跳到真实的嵌套页面,
  // 否则未匹配到任何路由会落到 403 兜底页。
  {
    key: 'tenant/alias/topology',
    path: 'topology',
    redirectTo: 'tenant/topology',
    menu: {
      hide: true
    }
  }, // tenant/events 路由已注释掉, 它的短路径别名一并停用(否则会落到 403 兜底页)
  // {
  //   key: 'tenant/alias/events',
  //   path: 'events',
  //   redirectTo: 'tenant/events',
  //   menu: { hide: true },
  // },
  {
    key: 'tenant/alias/sites',
    path: 'sites',
    redirectTo: 'tenant/network/sites',
    menu: {
      hide: true
    }
  }, {
    key: 'tenant/alias/rules',
    path: 'rules',
    redirectTo: 'tenant/network/rules',
    menu: {
      hide: true
    }
  }, {
    key: 'tenant/alias/bandwidth',
    path: 'bandwidth',
    redirectTo: 'tenant/network/bandwidth',
    menu: {
      hide: true
    }
  }, {
    key: 'tenant/alias/eips',
    path: 'eips',
    redirectTo: 'tenant/network/eips',
    menu: {
      hide: true
    }
  }]
}];
/** 兼容旧引用（components/NavBar、mock/user.ts） */

export const routes = routeConfig;
/** 兼容旧引用：按角色生成权限表 */

export const generatePermission = role => {
  const actions = role === 'admin' ? ['*'] : ['read'];
  const result = {};

  const travel = nodes => {
    for (const node of nodes) {
      if (node.children?.length) {
        travel(node.children);
      } else if (node.name) {
        result[node.name] = actions;
      }
    }
  };

  travel(routeConfig);
  return result;
};
/** 兼容旧引用：按路径反查 i18n name */

export const getName = (path, nodes = routeConfig) => {
  for (const node of nodes) {
    const nodePath = node.path.startsWith('/') ? node.path : `/${node.path}`;

    if (nodePath === path) {
      return node.name;
    }

    if (node.children?.length) {
      const found = getName(path, node.children);
      if (found) return found;
    }
  }

  return undefined;
};